"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var http_service_1 = require("./http.service");
var Subject_1 = require("rxjs/Subject");
var save_http_error_1 = require("../error/save-http-error");
var FileService = /** @class */ (function () {
    function FileService(_httpService) {
        this._httpService = _httpService;
        this.BULK_FILE_UPLOAD_ATTENDING = FileService.FILE_UPLOAD + "/attendingInfo";
        this.BULK_FILE_UPLOAD_APPRAISAL = FileService.FILE_UPLOAD + "/appraisal";
        this.BULK_FILE_UPLOAD_VALIDATION = FileService.FILE_UPLOAD + "/validation";
        this.saveSubject = new Subject_1.Subject();
        this.save$ = this.saveSubject.asObservable();
        this.errorSubject = new Subject_1.Subject();
        this.error$ = this.errorSubject.asObservable();
    }
    FileService.prototype.saveAttendingFiles = function (files, attendingInfo) {
        try {
            return this.saveFiles(files, this.BULK_FILE_UPLOAD_ATTENDING, 'attending', 'attendingInfoId', attendingInfo.id);
        }
        catch (e) {
            return this.saveFiles(files, this.BULK_FILE_UPLOAD_ATTENDING, 'attending');
        }
    };
    FileService.prototype.saveAppraisalFiles = function (files, appraisal) {
        try {
            return this.saveFiles(files, this.BULK_FILE_UPLOAD_APPRAISAL, 'appraisal', 'appraisalId', appraisal.id);
        }
        catch (e) {
            return this.saveFiles(files, this.BULK_FILE_UPLOAD_ATTENDING, 'appraisal');
        }
    };
    FileService.prototype.saveValidationFiles = function (files, validation) {
        try {
            return this.saveFiles(files, this.BULK_FILE_UPLOAD_VALIDATION, 'validation', 'validationId', validation.id);
        }
        catch (e) {
            return this.saveFiles(files, this.BULK_FILE_UPLOAD_VALIDATION, 'validation');
        }
    };
    FileService.prototype.saveFiles = function (files, url, targetFolder, entityIdLabel, entityId) {
        var _this = this;
        var entityParam = entityId ? entityIdLabel + "=" + entityId + "&" : '';
        this.updateFilesUrl(files);
        var formData = this.createFormData(files);
        if (files && files.length > 0) {
            this._httpService.post(url + "?" + entityParam + "targetFolder=/" + targetFolder, formData, Array, save_http_error_1.SaveHttpError)
                .subscribe(function (savedFiles) {
                _this.saveSubject.next(savedFiles);
            }, function (error) {
                error.text = 'Erro ao salvar as imagens!';
                _this.errorSubject.next(error);
            });
        }
        else {
            this.saveSubject.next();
        }
    };
    FileService.prototype.createFormData = function (files) {
        var formData = new FormData();
        if (files.length > 0) {
            for (var index = 0; index < files.length; index++) {
                formData.append('files[]', files[index]);
            }
        }
        return formData;
    };
    FileService.prototype.updateFilesUrl = function (files) {
        for (var _i = 0, files_1 = files; _i < files_1.length; _i++) {
            var file = files_1[_i];
            try {
                file.url = file.url.changingThisBreaksApplicationSecurity;
            }
            catch (e) { }
        }
    };
    FileService.ctorParameters = function () { return [{ type: http_service_1.HttpService }]; };
    FileService.FILE_UPLOAD = '/file';
    return FileService;
}());
exports.FileService = FileService;
//# sourceMappingURL=file.service.js.map


// WEBPACK FOOTER //
// file.service.js